import Vue from 'vue'

import Notification  from './VueBulmaNotification';
//import BugsnagClient from '@utilities/bugsnag';

const NotificationComponent = Vue.extend(Notification);
const openNotification      = (propsData = {
        title: '',
        message: '',
        type: '',
        direction: '',
        duration: '',
        container: '.notifications'
    }) => {
        return new NotificationComponent({
            el: document.createElement('div'),
            propsData
        });
    };


export const notifySuccess = function (message) {
    openNotification({
        message: message,
        type:    'success'
    });
};


// Several requests failing for the same reason (e.g. database briefly unreachable)
// would otherwise stack identical toasts.
let lastError = { message: null, at: 0 };

export const notifyError = function (message) {
    const now = Date.now();
    if (message === lastError.message && now - lastError.at < 3000) {
        return;
    }
    lastError = { message, at: now };

    openNotification({
        message: message,
        type:    'danger'
    });

    //BugsnagClient.notify(message);
};

